/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */

//@ts-nocheck
import React, { useState } from 'react';
import { useTheme } from '@/providers/theme';
import { useSMweatherAnalytics } from '@pages/EventTrackerPage/machines';

import { Header, BackArrowComp, CalendarComp } from '../components';
import { NotificationModal } from '@vlinder-web/notification-modal-v2-widget-react';
import { EventTrackerPageService } from '@pages/EventTrackerPage/services';
import { vappContainer } from '@/application';

const moment = require('moment');

const getSrv = () => {
  return vappContainer.get<EventTrackerPageService>(
    EventTrackerPageService.displayName
  );
};

export const ContainerComm = (props: any) => {
  const staticPageContentConfig = getSrv()?.agent?.getStaticContentSync();

  const srv = getSrv();
  console.log('static data', staticPageContentConfig);
  const {
    weatherAnalyticsState,
    weatherAnalyticsMachine,
    weatherAnalyticsSend,
  } = useSMweatherAnalytics({});

  console.log('paginate', weatherAnalyticsState?.event?.data?.value);
  //console.log("paginate2",weatherAnalyticsState?.event?.data?.value?.isEmpty);

  const onRefresh = () => {
    weatherAnalyticsSend('TRIGGER_REFRESH', {});
  };
  const renderEvents = (data: string) => {
    let _temp = data.split(' ');
    console.log('split data', _temp);
    weatherAnalyticsSend('TRIGGER_REFRESH', {
      offset: 0,
      size: 31,
      year: _temp?.pop(),
      month: moment().month(_temp?.pop()).format('M'),
    });
  };

  const _renderErrorModals = () => {
    if (weatherAnalyticsState?.matches('RENDER_PAGE_ERROR')) {
      return (
        <NotificationModal
          showModal={true}
          {...(staticPageContentConfig?.error?.getTemplateList || {})}
          onAcknowledgement={onRefresh}
          onDeny={props?.goBack}
        />
      );
    }
  };

  const _renderHeader = () => {
    if (staticPageContentConfig?.header) {
      return (
        <>
          <BackArrowComp />
          <Header {...(staticPageContentConfig?.header || {})} />
        </>
      );
    }
    return null;
  };

  const _renderPage = () => {
    return (
      <>
        <div className="mx-5">
          <CalendarComp
            {...(weatherAnalyticsState?.event?.data?.value || {})}
            onCalendarChange={renderEvents}
            onViewMoreClick={props?.onRowClick}
          />
        </div>
      </>
    );
  };
  return (
    <>
      {_renderHeader()}
      {_renderPage()}
      {_renderErrorModals()}
    </>
  );
};
